import setting from './settings';

export default (() => {
  return {
    'AUTH': setting.api.AUTH,
    'ADMIN_LOGIN': setting.api.url + 'admin/login',
    'ADMIN_LOGOUT': setting.api.url + 'admin/logout',
    'FORGOT_PASSWORD': setting.api.url + 'admin/forgotPassword',
    'RESET_PASSWORD': setting.api.url + 'admin/resetPassword',
    'USER_LIST': setting.api.url + 'admin/user/usersList',
    'USER_ACCOUNT': setting.api.url + 'admin/userProfile',
    'USER_ACCOUNT_UPDATE': setting.api.url + 'admin/user/update',
    'CREATE_CUSTOMER': setting.api.url + 'admin/createStripeCustomer',
    'UPDATE_CREDIT': setting.api.url + 'admin/updateUserCredits',
    'UPDATE_THRESHOLd_CREDIT': setting.api.url + 'admin/updateThresholdCredit',
    'UPDATE_SHOW_CREDIT': setting.api.url + 'admin/updateShowCredits',
    'UPDATE_USER_PACK_CREDIT': setting.api.url + 'admin/updatePackCredits',
    'CREATE_SUBSCRIPTION': setting.api.url + 'admin/createSubscription',
    'CANCEL_SUBSCRIPTION': setting.api.url + 'user/cancelSubscription',
    'CREATE_CHARGE': setting.api.url + 'user/createCharge',
    'CREATE_CHARGE_3D': setting.api.url + 'user/createChargeByAuthenticatedCard',
    'UPDATE_SUBSCRIPTION': setting.api.url + 'admin/updateSubscription',
    'ADD_CARD': setting.api.url + 'user/addCard',
    'UPDATE_CARD': setting.api.url + 'user/updateCard',
    'GET_CARD': setting.api.url + 'user/getCard',
    'GET_INVOICES': setting.api.url + 'admin/listInvoices',
    'GET_CHARGE_BILL': setting.api.url + 'admin/listCharges',
    'UPLOAD_BG': setting.api.url + 'admin/upload',
    'SET_BG': setting.api.url + 'admin/setBackground',
    'UPDATE_ACTIVE_LOGO': setting.api.url + 'admin/updateLogoStatus',

    'DEL_BG': setting.api.url + 'admin/deleteOne',
    'DEL_ACCOUNT': setting.api.url + 'admin/user/delete',
    'GET_STRIPE_PRICE': setting.api.url + 'admin/stripePrices',
    'GET_CREDIT_PACK': setting.api.url + 'credit/getCreditPlans',
    'CAR_LIST': setting.api.url + 'admin/car/carsList',
    'LUX_LIST': setting.api.url + 'lux/viewAll',
    'CREATE_LUX': setting.api.url + 'lux/upload',
    'DELETE_LUX': setting.api.url + 'lux/delete',
    'UPDATE_LUX': setting.api.url + 'lux/update',
    'CREDITS_LIST': setting.api.url + 'credit/getCreditPlans',
    'CREATE_CREDITS': setting.api.url + 'credit/addCreditPlans',
    'DELETE_CREDITS': setting.api.url + 'credit/deleteCreditPlan',
    'UPDATE_MODULE_CREDITS': setting.api.url + 'credit/updateCreditPlans',

    'CREATE_ADDRESS': setting.api.url + 'address/addAddress',
    'DELETE_ADDRESS': setting.api.url + 'address/deleteAddress',
    'UPDATE_ADDRESS': setting.api.url + 'address/updateAddress',
    'ADDRESS_LIST': setting.api.url + 'address/getAddress',

    'CREATE_CURRENCY': setting.api.url + 'currency/addCurrency',
    'DELETE_CURRENCY': setting.api.url + 'currency/deleteCurrency',
    'UPDATE_CURRENCY': setting.api.url + 'currency/updateCurrency',
    'CURRENCY_LIST': setting.api.url + 'currency/getCurrency',

    'GET_CURRENCY':setting.api.url + 'currency/getCurrency',

    'COUPONS_LIST': setting.api.url + 'coupons/getAllCoupon',
    'COUPONS_BY_ID': setting.api.url + 'coupons/getCouponById',
    'CREATE_COUPONS': setting.api.url + 'admin/createCoupon',
    'ADD_USER_COUPONS': setting.api.url + 'admin/updateUserCoupon',
    'UPDATE_TAX': setting.api.url + 'admin/taxStatus',
    'DELETE_COUPONS': setting.api.url + 'admin/deleteCoupon',
    'UPDATE_COUPONS': setting.api.url + 'admin/updateCoupon',

    'BACKGROUND_LIST': setting.api.url + 'admin/background/viewAll',
    'CREATE_BACKGROUND': setting.api.url + 'admin/background/upload',
    'DELETE_BACKGROUND': setting.api.url + 'admin/background/deleteOne',
    'GET_FEEDBACKS': setting.api.url + 'admin/feedbacks/view',
    'GET_DASHBOARD': setting.api.url + 'admin/getCounts',
    'ADMIN_CHANGE_PASS':  setting.api.url + 'admin/update',
    'ADMIN_INVOICE_HISTORY': setting.api.url +'user/adminGetSingleCharges',
    'ADMIN_GENERATE_REPORT': setting.api.url +'user/generateReports',
  }
})()